export default {
  title: 'Facturi',
  form: {
    auto_generate_invoices: {
      label: 'Generare automată facturi',
    },
  },
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
